import React from "react";
import "./index.scss";

import { useSelector } from "react-redux";
import axios from "axios";
import * as backendModule from "../../../modules/backendModule";
import Spinner from "../../../components/customComponents/Spinner";
import { useNavigate } from "react-router-dom";

import { Chart, ArcElement } from 'chart.js'
import { CategoryScale } from 'chart.js'
import { registerables } from 'chart.js';

import { Pie, Bar } from 'react-chartjs-2';

const PublisherDashboardLanding = (props) => {
    const [data, setData] = React.useState();
    const [filters, setFilters] = React.useState(props.filters);
    const [packages, setPackages] = React.useState([]);
    const curUserSelector = useSelector(state => state?.userData?.userData?.UserInfo);

    const curNavigate = useNavigate();


    const getData = () => {
        setData(null)
        axios({
            method: "POST",
            url: `${backendModule.backendURL}/statistic/getPublisherStatisticByLanding`,
            data: {
                filters: filters
            },
            ...backendModule.axiosConfig
        }).then(res => {
            setData(res.data);
        }).catch((e) => {
            setData(backendModule.axiosConfig);
        });
    };

    React.useEffect(() => {
        getData()
    }, [filters]);


    React.useEffect(() => {
        setFilters(props.filters)
    }, [props.filters]);


    Chart.register(ArcElement);
    Chart.register(CategoryScale);
    Chart.register(...registerables);


    let colors = [
        "#FFA459",
        "#FF59DB",
        "#FF59A0",
        "#59FFEC",
        "#59C6FF",
        "#598BFF",
        "#5963FF",
        "#8F59FF",
        "#B759FF",
        "#FFED59",
        "#9FFF59",
        "#59FF74",
        "#59FFA4",
        "#59FFD3",
        "#5999FF",
        "#FF5959",
        "#FFA059",
        "#FFCC59",
        "#FFE659",
        "#FFFE59",
        "#D8FF59",
        "#59FF5E",
        "#59FFB6",
        "#F459FF",
        "#FF59CE",
        "#FF597C",
        "#FF6259",
        "#FF7F59",
        "#FF9959",
        "#FFB559",
        "#FFD959",
        "#FFF759",
        "#C0FF59",
        "#59FF66",
        "#59FF96",
        "#59FFC6",
        "#59A8FF",
        "#5986FF",
        "#5962FF",
        "#A159FF",
        "#C659FF",
        "#F459FF",
        "#FF5C59",
        "#FF7259",
        "#FF8A59",
        "#FFC059",
        "#FFDA59",
        "#596BFF",
        "#5954FF",
        "#8C59FF"
    ];


    return <div className="component__dashboard__content">
        {data ? <>
            <div className="component__dashboard__content__row">
                <p>Marketing type</p>
                <p>Clicks</p>
                <p>SOI</p>
                <p>CR (Reg)</p>
                <p>DOI</p>
                <p>CR (DOI)</p>
                <p>Unique sales</p>
                <p>Tail sales</p>
                <p>Total sales</p>
                <p>Commisions RevShare</p>
                <p>Commisions SOI</p>
                <p>Commisions DOI</p>
                <p>Commisions total</p>
                <p>Earnings per Click</p>

            </div>
            {Object.keys(data.data).map((item, index) => {
                return <div className={`component__dashboard__content__row ${index % 2 === 0 && "component__dashboard__content__row-2"} `}>
                    <p>{data?.data?.[item]?.Website !== "Unknown" ? <>
                        {data?.data?.[item]?.Website?.WebsiteName}
                        <img style={{ maxWidth: "100%" }} src={data?.data?.[item]?.Website?.Image} />
                        {data?.data?.[item]?.Offer?.Name} ({data?.data?.[item]?.Offer?.Type})
                    </> : <>Unknown <br />
                        {data?.data?.[item]?.Offer?.Name ? data?.data?.[item]?.Offer?.Name : ""} &nbsp;
                        {data?.data?.[item]?.Offer?.Type ? data?.data?.[item]?.Offer?.Type : ""}
                    </>}</p>
                    <p>{data.data[item]?.leads.View ? data.data[item]?.leads.View : 0}</p>
                    <p>{data.data[item]?.leads.Registration ? data.data[item]?.leads.Registration : 0}</p>
                    <p>{(data.data[item]?.leads.Registration && data.data[item]?.leads.View) ?
                        (Number(data.data[item]?.leads.Registration) / Number(data.data[item]?.leads.View) * 100).toFixed(2) : 0} %</p>
                    <p>{data.data[item]?.leads.Verification ? data.data[item]?.leads.Verification : 0}</p>
                    <p>{(data.data[item]?.leads.Verification && data.data[item]?.leads.Registration) ?
                        (Number(data.data[item]?.leads.Verification) / Number(data.data[item]?.leads.Registration) * 100).toFixed(2) : 0} %</p>
                    <p>{data.data[item]?.users ? (() => {
                        let tmp = 0;
                        Object.keys(data.data[item]?.users).map(user => {
                            tmp += data.data[item]?.users[user][0]
                        })
                        return tmp.toFixed(2);
                    })() : 0} € </p>
                    <p>{data.data[item]?.users ? (() => {
                        let tmp = 0;
                        Object.keys(data.data[item]?.users).map(user => {
                            if (data.data[item]?.users[user].length > 1) {
                                data.data[item]?.users[user].map((item, index) => {
                                    if (index > 0) {
                                        tmp += item;
                                    }
                                })
                            }
                        })
                        return tmp.toFixed(2);
                    })() : 0} €</p>
                    <p>{data.data[item]?.users ? (() => {
                        let tmp = 0;
                        Object.keys(data.data[item]?.users).map(user => {
                            data.data[item]?.users[user].map((item, index) => {
                                tmp += item;
                            })
                        })
                        return tmp.toFixed(2);
                    })() : 0} €</p>
                    <p>{data.data[item]?.commisions.RevShare ? data.data[item]?.commisions.RevShare.toFixed(2) : 0} €</p>
                    <p>{data.data[item]?.commisions["CPA-SOI"] ? data.data[item]?.commisions["CPA-SOI"].toFixed(2) : 0} €</p>
                    <p>{data.data[item]?.commisions["CPA-DOI"] ? data.data[item]?.commisions["CPA-DOI"].toFixed(2) : 0} €</p>
                    <p>{(() => {
                        let tmp = 0;
                        if (data.data[item]?.commisions.RevShare) tmp += data.data[item]?.commisions.RevShare;
                        if (data.data[item]?.commisions["CPA-SOI"]) tmp += data.data[item]?.commisions["CPA-SOI"];
                        if (data.data[item]?.commisions["CPA-DOI"]) tmp += data.data[item]?.commisions["CPA-DOI"];
                        return tmp.toFixed(2);
                    })()} €</p>
                    <p>{(() => {
                        let tmp = 0;
                        if (data.data[item]?.commisions.RevShare) tmp += data.data[item]?.commisions.RevShare;
                        if (data.data[item]?.commisions["CPA-SOI"]) tmp += data.data[item]?.commisions["CPA-SOI"];
                        if (data.data[item]?.commisions["CPA-DOI"]) tmp += data.data[item]?.commisions["CPA-DOI"];
                        return (tmp / data.data[item]?.leads.View).toFixed(2);
                    })()} €</p>

                </div>
            })}
            {(() => {
                let tmpViews = 0;
                let tmpSoi = 0;
                let tmpCRReg = 0;
                let tmpDoi = 0;
                let crDoi = 0;
                let tmpUS = 0;
                let tmpTS = 0;
                let tmpTotalS = 0
                let cRev = 0;
                let cSOI = 0;
                let cDOI = 0;
                let cTotal = 0;

                Object.keys(data?.data).forEach(item => {
                    tmpViews += data.data[item]?.leads?.View ? data.data[item]?.leads?.View : 0;
                    tmpSoi += data.data[item]?.leads?.Registration ? data.data[item]?.leads?.Registration : 0;
                    tmpDoi += data.data[item]?.leads?.Verification ? data.data[item]?.leads?.Verification : 0;
                    Object.keys(data.data[item]?.users).map(user => {
                        tmpUS += data.data[item]?.users[user][0] ? data.data[item]?.users[user][0] : 0
                    })
                    Object.keys(data.data[item]?.users).map(user => {
                        if (data.data[item]?.users[user].length > 1) {
                            data.data[item]?.users[user].map((item, index) => {
                                if (index > 0) {
                                    tmpTS += item ? item : 0;
                                }
                            })
                        }
                    })
                    Object.keys(data.data[item]?.users).map(user => {
                        data.data[item]?.users[user].map((item, index) => {
                            tmpTotalS += item ? item : 0;
                        })
                    })
                    cRev += data.data[item]?.commisions?.RevShare ? Number(data.data[item]?.commisions?.RevShare) : 0;
                    cSOI += data.data[item]?.commisions["CPA-SOI"] ? Number(data.data[item]?.commisions["CPA-SOI"]) : 0;
                    cDOI += data.data[item]?.commisions["CPA-DOI"] ? Number(data.data[item]?.commisions["CPA-DOI"]) : 0;
                })
                tmpCRReg = (tmpSoi / tmpViews * 100).toFixed(2);
                crDoi = (tmpDoi / tmpSoi * 100).toFixed(2);
                cTotal = cRev + cSOI + cDOI;



                return <div className={`component__dashboard__content__row ${Object.keys(data.data)?.length % 2 === 0 && "component__dashboard__content__row-2"} `}>
                    <p>Total</p>
                    <p>{tmpViews}</p>
                    <p>{tmpSoi}</p>
                    <p>{tmpCRReg} %</p>
                    <p>{tmpDoi}</p>
                    <p>{crDoi} %</p>
                    <p>{tmpUS.toFixed(2)} €</p>
                    <p>{tmpTS.toFixed(2)} €</p>
                    <p>{tmpTotalS.toFixed(2)} €</p>
                    <p>{cRev.toFixed(2)} €</p>
                    <p>{cSOI.toFixed(2)} €</p>
                    <p>{cDOI.toFixed(2)} €</p>
                    <p>{cTotal.toFixed(2)} €</p>
                    <p>{(cTotal / tmpViews).toFixed(2)} €</p>
                </div>
            })()}
        </> : <Spinner align={"center"} color={"#6c5dd3"} />}

        {data?.data && <div className="component__dashboard__content__charts">
            <div>
                <p>Clicks</p>
                {data && <Pie data={{
                    labels: Object.keys(data.data).map((item, index) => {
                        return `${data?.data?.[item]?.Website !== "Unknown" ?
                            data?.data?.[item]?.Website?.WebsiteName : "Unknown"} (${data.data[item]?.leads?.View ? data.data[item]?.leads?.View : 0})`;
                    }),
                    datasets: [{
                        label: "Clicks per domain",
                        data: Object.keys(data.data).map((item, index) => {
                            return data.data[item]?.leads?.View ? data.data[item]?.leads?.View : 0;
                        }),
                        backgroundColor: colors
                    }]
                }} />}
            </div>
            <div>
                <p>SOI</p>
                {data && <Pie data={{
                    labels: Object.keys(data.data).map((item, index) => {
                        return `${data?.data?.[item]?.Website !== "Unknown" ?
                            data?.data?.[item]?.Website?.WebsiteName : "Unknown"} (${data.data[item]?.leads?.Registration ? data.data[item]?.leads?.Registration : 0})`;
                    }),
                    datasets: [{
                        label: "SOI",
                        data: Object.keys(data.data).map((item, index) => {
                            return data.data[item]?.leads?.Registration ? data.data[item]?.leads?.Registration : 0;
                        }),
                        backgroundColor: colors
                    }]
                }} />}
            </div>
            <div>
                <p>DOI</p>
                {data && <Pie data={{
                    labels: Object.keys(data.data).map((item, index) => {
                        return `${data?.data?.[item]?.Website !== "Unknown" ?
                            data?.data?.[item]?.Website?.WebsiteName : "Unknown"} (${data.data[item]?.leads?.Verification ? data.data[item]?.leads?.Verification : 0})`;
                    }),
                    datasets: [{
                        label: "DOI",
                        data: Object.keys(data.data).map((item, index) => {
                            return data.data[item]?.leads?.Verification ? data.data[item]?.leads?.Verification : 0;
                        }),
                        backgroundColor: colors
                    }]
                }} />}
            </div>
            <div>
                <p>Earnings</p>
                {data && <Pie data={{
                    labels: Object.keys(data.data).map((item, index) => {
                        let tmp = 0;
                        if (data.data[item]?.commisions.RevShare) tmp += data.data[item]?.commisions.RevShare;
                        if (data.data[item]?.commisions["CPA-SOI"]) tmp += data.data[item]?.commisions["CPA-SOI"];
                        if (data.data[item]?.commisions["CPA-DOI"]) tmp += data.data[item]?.commisions["CPA-DOI"];
                        return `${data?.data?.[item]?.Website !== "Unknown" ?
                            data?.data?.[item]?.Website?.WebsiteName : "Unknown"} (${tmp.toFixed(2)} €)`;
                    }),
                    datasets: [{
                        label: "Earnings",
                        data: Object.keys(data.data).map((item, index) => {
                            let tmp = 0;
                            if (data.data[item]?.commisions.RevShare) tmp += data.data[item]?.commisions.RevShare;
                            if (data.data[item]?.commisions["CPA-SOI"]) tmp += data.data[item]?.commisions["CPA-SOI"];
                            if (data.data[item]?.commisions["CPA-DOI"]) tmp += data.data[item]?.commisions["CPA-DOI"];
                            return tmp.toFixed(2);
                        }),
                        backgroundColor: colors
                    }]
                }} />}
            </div>


        </div>}

    </div>


};



export default PublisherDashboardLanding;